import React, { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Trash2, Mail } from "lucide-react";

function fmtDate(iso) {
    try {
        return new Date(iso).toLocaleString("es-ES");
    } catch {
        return "";
    }
}

export default function MessagesManager() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const load = async () => {
        setLoading(true);
        try {
            const { data } = await api.get("/admin/messages");
            setItems(data);
        } catch (e) {
            setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        load();
    }, []);

    const remove = async (m) => {
        if (!window.confirm("¿Eliminar este mensaje?")) return;
        try {
            await api.delete(`/admin/messages/${m.id}`);
            load();
        } catch (e) {
            setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
        }
    };

    return (
        <div data-testid="admin-messages">
            <div className="mb-8">
                <div className="text-xs uppercase tracking-widest text-[#082050]/70">Administración</div>
                <h1 className="mt-2 text-3xl font-semibold text-[#082050] tracking-tight">Mensajes de contacto</h1>
            </div>

            {error && <div className="mb-6 text-sm text-red-600 border border-red-500 bg-red-50 px-4 py-3">{error}</div>}

            <div className="space-y-4">
                {loading && <div className="text-[#4A5568]">Cargando...</div>}
                {!loading && items.length === 0 && (
                    <div className="text-[#4A5568] bg-white border border-[#E2E4E9] p-8 text-center">Sin mensajes</div>
                )}
                {items.map((m, i) => (
                    <article key={m.id} data-testid={`admin-message-${i}`} className="bg-white border border-[#E2E4E9] p-6">
                        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
                            <div>
                                <div className="text-base font-semibold text-[#082050]">{m.name}</div>
                                <div className="text-xs text-[#718096]">{m.email} · {m.phone || "sin teléfono"}</div>
                                {m.subject && <div className="mt-2 text-sm text-[#082050]">Asunto: {m.subject}</div>}
                            </div>
                            <div className="text-xs text-[#718096]">{fmtDate(m.created_at)}</div>
                        </div>
                        <p className="mt-4 text-sm text-[#4A5568] whitespace-pre-line leading-relaxed">{m.message}</p>
                        <div className="mt-4 pt-4 border-t border-[#E2E4E9] flex items-center gap-4 text-xs">
                            <a href={`mailto:${m.email}`} className="inline-flex items-center gap-1 text-[#082050] hover:opacity-70">
                                <Mail size={12} /> Responder por email
                            </a>
                            <button
                                onClick={() => remove(m)}
                                data-testid={`admin-message-delete-${i}`}
                                className="inline-flex items-center gap-1 text-red-600 hover:opacity-70"
                            >
                                <Trash2 size={12} /> Eliminar
                            </button>
                        </div>
                    </article>
                ))}
            </div>
        </div>
    );
}
